export const RUBRIC_GROUPS = {
  preparation_sheet_1: {
    key: 'preparation_sheet_1',
    name: 'PREPARATION SHEET #1',
    scoreLabel: 'PREPARATION SHEET #1 SCORE',
    items: [
      {
        label: 'Sheet is fully completed by student',
        scores: [
          {
            score: 10,
            description:
              'Sheet was thoughtfully completed by student shown by following directions, using complete sentences and basic grammar expectations.',
          },
          {
            score: 6,
            description: 'Sheet was completed by student but requires more work. Shown by incomplete sentences, but all questions are answered.',
          },
          {
            score: 2,
            description: 'Sheet completion needs significant improvement. Missing key information, using one word answers.',
          },
          {
            score: 0,
            description: 'Sheet was not completed.',
          },
        ],
      },
      {
        label: 'Sheet is submitted on time',
        scores: [
          {
            score: 5,
            description: 'Sheet was submitted on time.',
          },
          {
            score: 3,
            description: 'Sheet was submitted within 24 hours of due date.',
          },
          {
            score: 1,
            description: 'Sheet was submitted between 2 to 3 days after due date.',
          },
          {
            score: 0,
            description: 'Sheet was submitted 4 days or more after due date.',
          },
        ],
      },
      {
        label: 'Overall Social Skills (Greeting & Conversation)',
        scores: [
          {
            score: 4,
            description:
              'Greets others appropriately without prompting. Uses spontaneous engagement, participates in appropriate conversations. Acknowledges and recognizes individuals previously met.',
          },
          {
            score: 3,
            description: 'Greets others appropriately without prompting. Participates in appropriate conversations.',
          },
          {
            score: 2,
            description: 'Greets others after being prompted; conversation is minimal or awkward.',
          },
          {
            score: 0,
            description: 'Does not greet others; avoids conversation or is inappropriate/disrespectful.',
          },
        ],
      },
      {
        label: 'Dressed Appropriately',
        scores: [
          {
            score: 3,
            description: 'Attire is fully appropriate for the setting and occasion; neat and clean.',
          },
          {
            score: 2,
            description: 'Attire is mostly appropriate; minor issues (i.e., wrinkled, leaves coat on, facial hair, jeans, etc.).',
          },
          {
            score: 1,
            description: 'Attire is somewhat inappropriate or untidy; needs improvement.',
          },
          {
            score: 0,
            description: 'Attire is clearly inappropriate or unkempt for the setting.',
          },
        ],
      },
      {
        label: 'Communication',
        scores: [
          {
            score: 6,
            description: 'Expresses thoughts clearly and respectfully; listens actively and responds appropriately.',
          },
          {
            score: 4,
            description: 'Communicates effectively with minor issues; listens and responds adequately.',
          },
          {
            score: 2,
            description: 'Communication is unclear or occasionally inappropriate; listening skills need work.',
          },
          {
            score: 0,
            description: 'Communication is poor, disrespectful, or disruptive; does not listen or respond appropriately.',
          },
        ],
      },
      {
        label: 'Participation',
        scores: [
          {
            score: 6,
            description:
              'Actively participates throughout; contributes meaningfully and stays engaged. Independently takes notes and asks clarifying questions.',
          },
          {
            score: 4,
            description: 'Participates regularly; contributions are generally relevant. Adults provide minor prompting including notetaking.',
          },
          {
            score: 2,
            description: 'Participates occasionally; contributions are minimal or off-topic. Family Teachers do most of the talking and notetaking.',
          },
          {
            score: 0,
            description: 'Rarely participates; disengaged or disruptive.',
          },
        ],
      },
      {
        label: 'Willingness to Accept Feedback',
        scores: [
          {
            score: 6,
            description: 'Accepts feedback openly and respectfully; asks questions to demonstrate understanding.',
          },
          {
            score: 4,
            description: 'Accepts feedback with minor resistance; makes excuses.',
          },
          {
            score: 2,
            description: 'Accepts feedback reluctantly; openly displays resistance (crying, rolling eyes, etc.).',
          },
          {
            score: 0,
            description: 'Rejects feedback; shows no effort to change or improve behavior.',
          },
        ],
      },
    ],
    total: 40,
  },
  module_1: {
    key: 'module_1',
    name: 'MODULE #1',
    scoreLabel: 'MODULE #1 TOTAL SCORE',
    items: [
      {
        label: 'Modules were fully completed on time',
        scores: [
          {
            score: 8,
            description: 'Module completed in full by due date; 100% completion status shown in platform.',
          },
          {
            score: 6,
            description: 'Module mostly completed 75–99%.',
          },
          {
            score: 4,
            description: 'Module less than 75% complete.',
          },
          {
            score: 0,
            description: 'Module not started or under 50% complete by the due date.',
          },
        ],
      },
      {
        label: 'Module 1.1 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 1.2 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 1.3 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 1.4 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
    ],
    total: 20,
  },
  module_2: {
    key: 'module_2',
    name: 'MODULE #2 - Online Lessons',
    scoreLabel: 'MODULE #2 TOTAL SCORE',
    items: [
      {
        label: 'Modules were fully completed on time',
        scores: [
          {
            score: 8,
            description: 'Module completed in full by due date; 100% completion status shown in platform.',
          },
          {
            score: 6,
            description: 'Module mostly completed 75–99%.',
          },
          {
            score: 4,
            description: 'Module less than 75% complete.',
          },
          {
            score: 0,
            description: 'Module not started or under 50% complete by the due date.',
          },
        ],
      },
      {
        label: 'Module 2.1 Activity Completion',
        scores: [
          {
            score: 6,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 4,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 2,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 2.2 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 2.3 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
    ],
    total: 20,
  },
  module_3: {
    key: 'module_3',
    name: 'MODULE #3 - Online Lessons',
    scoreLabel: 'MODULE #3 TOTAL SCORE',
    items: [
      {
        label: 'Modules were fully completed on time',
        scores: [
          {
            score: 8,
            description: 'Module completed in full by due date; 100% completion status shown in platform.',
          },
          {
            score: 6,
            description: 'Module mostly completed 75–99%.',
          },
          {
            score: 4,
            description: 'Module less than 75% complete.',
          },
          {
            score: 0,
            description: 'Module not started or under 50% complete by the due date.',
          },
        ],
      },
      {
        label: 'Module 3.1 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 3.2 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 3.3 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
      {
        label: 'Module 3.4 Activity Completion',
        scores: [
          {
            score: 3,
            description: 'Student received a score of 95-100.',
          },
          {
            score: 2,
            description: 'Student received a score of 80-94.',
          },
          {
            score: 1,
            description: 'Student received a score of 65-79.',
          },
          {
            score: 0,
            description: 'Student received a score of 64 or below.',
          },
        ],
      },
    ],
    total: 20,
  },
};
